import {
    SET_CALENDAR_SETTINGS,
    SET_CALENDAR_SETTINGS_FAILURE,
    SET_CALENDAR_SETTINGS_SUCCESS,
} from '../actions';

const initialState = {
    loading: false,
    statusCode: '',
    statusMessage: '',
};

const ApplyCalendarSettings = (state = initialState, action) => {
    switch (action.type) {
        case SET_CALENDAR_SETTINGS:
            return {
                ...state,
                loading: true,
            };
        case SET_CALENDAR_SETTINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                ...action.payload,
            };
        case SET_CALENDAR_SETTINGS_FAILURE:
            return {
                ...state,
                loading: false,
                ...action.payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default ApplyCalendarSettings;
